import React, { useState } from 'react';
import { HeaderBookACall } from '../components/heylloyd/HeaderBookACall';
import { HeroSectionBookACall } from '../components/heylloyd/HeroSectionBookACall';
import { Calendar, X } from 'lucide-react';
import { Button } from '../components/ui/Button';
export function HeyLloydBookACallPage() {
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  return <div className="min-h-screen bg-black font-sans text-white selection:bg-[#7FFF00]/20 selection:text-[#7FFF00]" data-id="element-2392" data-mp="13qxgga9mo3tv">
      <HeaderBookACall data-id="element-2393" data-mp="18nxnooi7rcmk" />
      <div id="hero" data-id="element-2394" data-mp="18qjycx0ei890">
        <HeroSectionBookACall data-id="element-2395" data-mp="uxu7of9xgf5k" />
      </div>

      {/* Book a Call CTA Section */}
      <section id="beneficios" className="py-12 md:py-20 lg:py-28 bg-gradient-to-b from-black to-gray-900" data-id="element-2396" data-mp="yyw82zfkyx94">
        <div className="container mx-auto px-4 max-w-4xl text-center" data-id="element-2397" data-mp="1moqjrdo5yfrs">
          <div className="mb-6 md:mb-10" data-id="element-2398" data-mp="1mmdx4n7gnh8e">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-4 md:mb-5 tracking-tight px-2" data-id="element-2399" data-mp="1rfgpis0i4kn0">
              Únete a la Revolución de la IA
              <span className="block text-[#7FFF00] mt-2" data-id="element-2400" data-mp="2gcv515g2p7ax">
                Más Fácil que Nunca
              </span>
            </h2>
            <p className="text-base md:text-lg text-gray-100 max-w-2xl mx-auto leading-relaxed px-2" data-id="element-2401" data-mp="2q5iyprbrav5f">
              Habla con nuestro equipo y descubre cómo implementar inteligencia
              artificial en tu negocio para crear y escalar productos digitales
              de forma profesional.
            </p>
          </div>

          <div id="proceso" className="bg-gray-900 rounded-2xl shadow-xl border border-gray-800 p-5 md:p-8 mb-6 max-w-2xl mx-auto" data-id="element-2402" data-mp="2v3c96wk3ebbi">
            <div className="space-y-5" data-id="element-2403" data-mp="391iy3n72d0z1">
              <div className="flex items-start gap-4 text-left" data-id="element-2404" data-mp="344irnb6axw7e">
                <div className="flex-shrink-0 w-9 h-9 md:w-10 md:h-10 rounded-full bg-[#7FFF00]/20 border border-[#7FFF00]/50 flex items-center justify-center" data-id="element-2405" data-mp="1epuf99xpoe9d">
                  <span className="text-[#7FFF00] font-bold text-sm md:text-base" data-id="element-2406" data-mp="19sc4rf41pqz9">
                    1
                  </span>
                </div>
                <div data-id="element-2407" data-mp="3ertvr00e7rhv">
                  <h3 className="font-bold text-white mb-1 text-base md:text-lg" data-id="element-2408" data-mp="3et50p35kr5ak">
                    Agenda tu llamada estratégica
                  </h3>
                  <p className="text-gray-200 text-sm md:text-base" data-id="element-2409" data-mp="3iw1nz7627pku">
                    Elige el horario que mejor se ajuste a tu agenda
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4 text-left" data-id="element-2410" data-mp="3sq1yjok41n0y">
                <div className="flex-shrink-0 w-9 h-9 md:w-10 md:h-10 rounded-full bg-[#7FFF00]/20 border border-[#7FFF00]/50 flex items-center justify-center" data-id="element-2411" data-mp="1k0nhg05atfb">
                  <span className="text-[#7FFF00] font-bold text-sm md:text-base" data-id="element-2412" data-mp="aef2dhgrk1xw">
                    2
                  </span>
                </div>
                <div data-id="element-2413" data-mp="favne2so206r">
                  <h3 className="font-bold text-white mb-1 text-base md:text-lg" data-id="element-2414" data-mp="kc2wc56jp5f0">
                    Consulta con expertos en IA
                  </h3>
                  <p className="text-gray-200 text-sm md:text-base" data-id="element-2415" data-mp="ugt4wtwgf7s7">
                    Nuestro equipo analizará tu caso y te mostrará cómo aplicar
                    IA a tu negocio específico
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4 text-left" data-id="element-2416" data-mp="ggic3lbl3j4e">
                <div className="flex-shrink-0 w-9 h-9 md:w-10 md:h-10 rounded-full bg-[#7FFF00]/20 border border-[#7FFF00]/50 flex items-center justify-center" data-id="element-2417" data-mp="gibkb51uibei">
                  <span className="text-[#7FFF00] font-bold text-sm md:text-base" data-id="element-2418" data-mp="188g1yvy80kc1">
                    3
                  </span>
                </div>
                <div data-id="element-2419" data-mp="zf2xqxuphwan">
                  <h3 className="font-bold text-white mb-1 text-base md:text-lg" data-id="element-2420" data-mp="zfmiembqqysd">
                    Recibe tu plan de acción
                  </h3>
                  <p className="text-gray-200 text-sm md:text-base" data-id="element-2421" data-mp="1vyaax2ff5or0">
                    Obtén una estrategia personalizada para implementar IA y
                    empezar a ver resultados
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-6 pt-6 border-t border-gray-800" data-id="element-2422" data-mp="1godpfuc6730d">
              <a href="https://api.leadconnectorhq.com/widget/bookings/info-commerce-llamada-de-claridad-crea-tu-producto-digital-con-ia" target="_blank" rel="noopener noreferrer" data-id="element-2423" data-mp="12nuhsobm9yyq">
                <Button variant="primary" size="lg" className="w-full text-base md:text-lg px-6 py-5 md:py-6 bg-[#7FFF00] hover:bg-[#6FEF00] text-black font-bold shadow-lg shadow-[#7FFF00]/20 hover:shadow-xl hover:shadow-[#7FFF00]/30" leftIcon={<Calendar className="w-5 h-5 md:w-6 md:h-6" data-id="element-2425" data-mp="1lmyovrjllinr" />} data-id="element-2424" data-mp="16qzf8cgubagi">
                  Agenda tu Llamada Estratégica Gratis
                </Button>
              </a>
              <p className="text-sm text-gray-200 mt-4" data-id="element-2426" data-mp="1plnxl6toyc12">
                Sin compromiso • Sesión de 30 minutos • Estrategia personalizada
              </p>
            </div>
          </div>

          <div id="resultados" className="grid grid-cols-3 gap-3 md:gap-6 max-w-3xl mx-auto" data-id="element-2427" data-mp="2i6fs1jpcvi9t">
            <div className="bg-gray-900 rounded-xl p-4 md:p-6 border border-gray-800" data-id="element-2428" data-mp="6njdg2pnsw0q">
              <div className="text-2xl md:text-3xl font-bold text-[#7FFF00] mb-1 md:mb-2" data-id="element-2429" data-mp="1pq5b44sprxt">
                100+
              </div>
              <p className="text-gray-200 text-xs md:text-sm" data-id="element-2430" data-mp="gh0818xmef5g">
                Negocios transformados con IA
              </p>
            </div>
            <div className="bg-gray-900 rounded-xl p-4 md:p-6 border border-gray-800" data-id="element-2431" data-mp="3jwxhffnyjj2q">
              <div className="text-2xl md:text-3xl font-bold text-[#7FFF00] mb-1 md:mb-2" data-id="element-2432" data-mp="3exkw4zcqik29">
                95%
              </div>
              <p className="text-gray-200 text-xs md:text-sm" data-id="element-2433" data-mp="3tvmzb8fut3iz">
                Clientes satisfechos
              </p>
            </div>
            <div className="bg-gray-900 rounded-xl p-4 md:p-6 border border-gray-800" data-id="element-2434" data-mp="193t95sex9gfz">
              <div className="text-2xl md:text-3xl font-bold text-[#7FFF00] mb-1 md:mb-2" data-id="element-2435" data-mp="195xjot7btdp8">
                24/7
              </div>
              <p className="text-gray-200 text-xs md:text-sm" data-id="element-2436" data-mp="1b8g3ob7xgatc">
                Soporte continuo
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="w-full relative z-10 bg-black border-t border-gray-900" data-id="element-2437" data-mp="1l6du95d9ejp4">
        <div className="max-w-5xl mx-auto px-4 md:px-6 py-4 md:py-6" data-id="element-2438" data-mp="1q575er52pym4">
          {/* Legal Disclaimer */}
          <div className="text-gray-300 text-[10px] leading-tight space-y-2 text-left" data-id="element-2439" data-mp="shozdo2sralt">
            <p data-id="element-2440" data-mp="xgjfujdakn2r">
              48 HRS AI CASH MACHINE y todo el equipo asociado no asume
              responsabilidad por los resultados, ingresos o éxito que puedas
              obtener, ni garantiza resultados específicos. El éxito depende en
              parte del tiempo que dediques y de tu implementación de las guías,
              estrategias y soporte proporcionados. Todo el contenido,
              entrenamientos, artículos y material educativo tiene fines
              formativos únicamente y no debe interpretarse como asesoría
              financiera, legal o de inversión.
            </p>

            <p data-id="element-2441" data-mp="2nyzrcbil37o0">
              Aunque nuestros servicios, sistemas y productos están diseñados
              para ayudar a nuestros clientes a crear y lanzar productos
              digitales con IA, no ofrecemos garantías (explícitas o implícitas)
              sobre resultados, ventas o ingresos derivados del uso de las
              ideas, herramientas o estrategias presentadas.
            </p>

            <p data-id="element-2442" data-mp="24azes14jsl3e">
              Los testimonios compartidos corresponden a experiencias reales de
              usuarios, pero no deben considerarse como resultados típicos, ya
              que cada persona obtiene resultados diferentes según su situación
              y las acciones que decida tomar.
            </p>

            <p data-id="element-2443" data-mp="1qb7sld3vnyeb">
              Cualquier cifra interna, ejemplo o caso de estudio mostrado tiene
              fines ilustrativos y no garantiza que tú obtendrás los mismos
              resultados.
            </p>

            <p data-id="element-2444" data-mp="3a73t0qg4ln95">
              Este sitio no forma parte de Google, Google Inc., Facebook/Meta o
              Meta Inc.
            </p>

            <p data-id="element-2445" data-mp="3e5jntgig7zx4">
              Además, este sitio no está avalado, patrocinado ni aprobado por
              Google ni Meta de ninguna manera.
            </p>
          </div>

          {/* Copyright */}
          <div className="text-center mt-4 pt-3 border-t border-gray-900" data-id="element-2446" data-mp="358slwnh7tqum">
            <p className="text-gray-300 text-[10px] mb-1" data-id="element-2447" data-mp="2qgifrudj2qsd">
              &copy; 2025 48 Hrs AI Cash Machine. Todos los derechos reservados.
            </p>
            <p className="text-gray-200 text-[10px] mb-1" data-id="element-2448" data-mp="2hhwwty4599r2">
              Soporte:{' '}
              <a href="mailto:support@truemarketer.com" className="text-[#7FFF00] hover:text-[#6FEF00] transition-colors" data-id="element-2449" data-mp="2mg87uc66dqav">
                support@truemarketer.com
              </a>
            </p>
            <div className="flex items-center justify-center gap-4 text-[10px]" data-id="element-2450" data-mp="2ci0u0276nod3">
              <button onClick={() => setShowTerms(true)} className="text-gray-200 hover:text-white transition-colors underline" data-id="element-2451" data-mp="2ck4tm7y1u17k">
                Términos
              </button>
              <span className="text-gray-400" data-id="element-2452" data-mp="1owq5pngv8zxh">|</span>
              <button onClick={() => setShowPrivacy(true)} className="text-gray-200 hover:text-white transition-colors underline" data-id="element-2453" data-mp="22v7qbcbh5wb6">
                Privacidad
              </button>
            </div>
          </div>
        </div>
      </footer>

      {/* Terms Modal */}
      {showTerms && <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4" onClick={() => setShowTerms(false)} data-id="element-2454" data-mp="27trfdlld7o7r">
          <div className="bg-gray-900 rounded-lg max-w-2xl w-full max-h-[80vh] overflow-y-auto p-6 md:p-8 relative border border-gray-800" onClick={e => e.stopPropagation()} data-id="element-2455" data-mp="2lk4j1br84gra">
            <button onClick={() => setShowTerms(false)} className="absolute top-4 right-4 text-gray-300 hover:text-white transition-colors" data-id="element-2456" data-mp="2vj3roubzocea">
              <X className="w-6 h-6" data-id="element-2457" data-mp="2qltx709qtajl" />
            </button>
            <h2 className="text-2xl md:text-3xl font-bold mb-6 text-white" data-id="element-2458" data-mp="1svjyeovyj0q0">
              Términos y Condiciones
            </h2>
            <div className="text-gray-200 text-sm md:text-base space-y-4 leading-relaxed" data-id="element-2459" data-mp="1o3if4j0dg9qh">
              <p data-id="element-2460" data-mp="1j68qv6opy448">
                Al registrarte y participar en el 48 Hrs AI Cash Machine
                Masterclass, aceptas los siguientes términos y condiciones:
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2461" data-mp="2bu4n6aadlu0h">
                1. Aceptación de Términos
              </h3>
              <p data-id="element-2462" data-mp="26w31dhlkfglb">
                Al acceder y utilizar este sitio web y registrarte para el
                evento, aceptas estar sujeto a estos términos y condiciones,
                todas las leyes y regulaciones aplicables.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2463" data-mp="re1cye0ll5tj">
                2. Uso del Servicio
              </h3>
              <p data-id="element-2464" data-mp="meeyk1919jj5">
                El contenido proporcionado en el masterclass es solo para fines
                educativos e informativos. No garantizamos resultados
                específicos de ingresos o éxito comercial.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2465" data-mp="331moqdkfdyp1">
                3. Propiedad Intelectual
              </h3>
              <p data-id="element-2466" data-mp="3715atcnzgftg">
                Todo el contenido, materiales, y recursos proporcionados son
                propiedad de 48 Hrs AI Cash Machine y están protegidos por
                derechos de autor. No está permitida la reproducción o
                distribución sin autorización expresa.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2467" data-mp="3qr8n4ysz49vz">
                4. Limitación de Responsabilidad
              </h3>
              <p data-id="element-2468" data-mp="3urizqub9tyjt">
                48 Hrs AI Cash Machine no será responsable de ningún daño
                directo, indirecto, incidental o consecuente que resulte del uso
                o la imposibilidad de usar nuestros servicios.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2469" data-mp="33pffyy0b7sam">
                5. Modificaciones
              </h3>
              <p data-id="element-2470" data-mp="2yqvrapuc02ek">
                Nos reservamos el derecho de modificar estos términos en
                cualquier momento. El uso continuado del servicio después de
                cambios constituye la aceptación de los nuevos términos.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2471" data-mp="38qmmyuumong8">Contacto</h3>
              <p data-id="element-2472" data-mp="3mmqe2fa7gfoh">
                Para preguntas sobre estos términos, contacta:{' '}
                <a href="mailto:support@truemarketer.com" className="text-[#7FFF00] hover:text-[#6FEF00]" data-id="element-2473" data-mp="3ho6ng1ko2fps">
                  support@truemarketer.com
                </a>
              </p>
            </div>
          </div>
        </div>}

      {/* Privacy Modal */}
      {showPrivacy && <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4" onClick={() => setShowPrivacy(false)} data-id="element-2474" data-mp="98vg1jy3jcy2">
          <div className="bg-gray-900 rounded-lg max-w-2xl w-full max-h-[80vh] overflow-y-auto p-6 md:p-8 relative border border-gray-800" onClick={e => e.stopPropagation()} data-id="element-2475" data-mp="4bmxhi91d6wa">
            <button onClick={() => setShowPrivacy(false)} className="absolute top-4 right-4 text-gray-300 hover:text-white transition-colors" data-id="element-2476" data-mp="svghzgled9hw">
              <X className="w-6 h-6" data-id="element-2477" data-mp="exi4seitbj3z" />
            </button>
            <h2 className="text-2xl md:text-3xl font-bold mb-6 text-white" data-id="element-2478" data-mp="ivzcp0a24xmg">
              Política de Privacidad
            </h2>
            <div className="text-gray-200 text-sm md:text-base space-y-4 leading-relaxed" data-id="element-2479" data-mp="54b1cz7mud6j">
              <p data-id="element-2480" data-mp="9xx33wc9cwnk">
                En 48 Hrs AI Cash Machine, nos comprometemos a proteger tu
                privacidad. Esta política describe cómo recopilamos, usamos y
                protegemos tu información personal.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2481" data-mp="3ic5p2lk9yp6r">
                1. Información que Recopilamos
              </h3>
              <p data-id="element-2482" data-mp="3nbig7ii6iif5">
                Recopilamos información que nos proporcionas directamente,
                incluyendo:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-2483" data-mp="3f9rlr6oo582l">
                <li data-id="element-2484" data-mp="3achnr2n7ro35">Nombre y dirección de correo electrónico</li>
                <li data-id="element-2485" data-mp="35khs3me6fhcd">Información de registro del evento</li>
                <li data-id="element-2486" data-mp="35iwx5vny9wdz">Comunicaciones que mantienes con nosotros</li>
              </ul>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2487" data-mp="31imqegsc31y2">
                2. Uso de la Información
              </h3>
              <p data-id="element-2488" data-mp="2whypn3eaz6qn">Utilizamos tu información para:</p>
              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-2489" data-mp="2rkoztmn04t2a">
                <li data-id="element-2490" data-mp="2mlvkrps2gu00">
                  Proporcionar acceso al masterclass y materiales relacionados
                </li>
                <li data-id="element-2491" data-mp="2il1zz59x7vbc">Enviar comunicaciones sobre el evento</li>
                <li data-id="element-2492" data-mp="2immwv1jpjqcd">Mejorar nuestros servicios y contenido</li>
                <li data-id="element-2493" data-mp="kt7ef7k4lqg0">Cumplir con obligaciones legales</li>
              </ul>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2494" data-mp="gsnmqjibnf19">
                3. Compartir Información
              </h3>
              <p data-id="element-2495" data-mp="1yq0q71rppxuy">
                No vendemos ni compartimos tu información personal con terceros
                para fines de marketing. Podemos compartir información con
                proveedores de servicios que nos ayudan a operar nuestro
                negocio.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2496" data-mp="2cgnctvk77xao">
                4. Seguridad de Datos
              </h3>
              <p data-id="element-2497" data-mp="1ftiq9x2pmrnm">
                Implementamos medidas de seguridad técnicas y organizativas
                apropiadas para proteger tu información personal contra acceso
                no autorizado, alteración o destrucción.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2498" data-mp="1tryw7lsr0e4p">
                5. Tus Derechos
              </h3>
              <p data-id="element-2499" data-mp="308azu2ecao7o">
                Tienes derecho a acceder, corregir o eliminar tu información
                personal. Para ejercer estos derechos, contáctanos en:{' '}
                <a href="mailto:support@truemarketer.com" className="text-[#7FFF00] hover:text-[#6FEF00]" data-id="element-2500" data-mp="15433ul9z3utc">
                  support@truemarketer.com
                </a>
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2501" data-mp="1f2iwwtsk9e5h">6. Cookies</h3>
              <p data-id="element-2502" data-mp="1f0g98gevrx3x">
                Utilizamos cookies y tecnologías similares para mejorar tu
                experiencia en nuestro sitio web y analizar el uso del sitio.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2503" data-mp="me4xqapqkbsc">Contacto</h3>
              <p data-id="element-2504" data-mp="hftr08uqmhec">
                Para preguntas sobre esta política de privacidad, contacta:{' '}
                <a href="mailto:support@truemarketer.com" className="text-[#7FFF00] hover:text-[#6FEF00]" data-id="element-2505" data-mp="w4q26es3caj6">
                  support@truemarketer.com
                </a>
              </p>
            </div>
          </div>
        </div>}
    </div>;
}